import {css} from "@emotion/react";

export const root = css`
    border: none;
    border-radius: 12px;
    background-color: #449DF7;
    padding: 14px 16px;
    color: white;
    box-shadow: 0 3px 0px rgba(0, 0, 0, 0.16);
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    outline: none;
    font-size: 16px;

    &:disabled {
        background-color: #a7a0a0;
    }
`;


export const rootFullWidth = css`
    width: 100%;
`;